/**
 * DeletePendingDomainDialog - Confirmação de exclusão de PendingDomain
 */
import React from 'react';
import {
    Button,
    CircularProgress,
    Typography,
    Alert,
    DialogContent,
    DialogActions
} from '@mui/material';
import { Delete as DeleteIcon, WarningAmber as WarningIcon } from '@mui/icons-material';
import PlatformDialog from '../../../molecules/PlatformDialog/PlatformDialog';
import PlatformDialogTitle from '../../../molecules/PlatformDialog/PlatformDialogTitle';

const DeletePendingDomainDialog = ({ open, domain, loading, onConfirm, onClose }) => {
    return (
        <PlatformDialog
            open={open}
            onClose={!loading ? onClose : undefined}
            maxWidth="xs"
            fullWidth
        >
            <PlatformDialogTitle
                title="Excluir Domínio"
                subtitle={domain?.domain}
                icon={<DeleteIcon />}
                onClose={!loading ? onClose : undefined}
                color="error"
            />

            <DialogContent sx={{ pt: 2 }}>
                <Typography variant="body2" color="text.secondary">
                    Tem certeza que deseja excluir permanentemente o domínio <strong>{domain?.domain}</strong>?
                </Typography>
                <Alert severity="error" variant="outlined" sx={{ mt: 2, borderRadius: 2 }}>
                    Esta ação <strong>não pode ser desfeita</strong> e o registro será removido do banco de dados.
                </Alert>
            </DialogContent>

            <DialogActions sx={{ px: 3, pb: 3, gap: 1.5 }}>
                <Button
                    onClick={onClose}
                    disabled={loading}
                    sx={{ fontWeight: 600 }}
                >
                    Cancelar
                </Button>
                <Button
                    onClick={onConfirm}
                    disabled={loading}
                    variant="contained"
                    color="error"
                    startIcon={loading ? <CircularProgress size={16} color="inherit" /> : <DeleteIcon />}
                    sx={{ fontWeight: 700, borderRadius: 2 }}
                >
                    {loading ? 'Excluindo...' : 'Excluir Domínio'}
                </Button>
            </DialogActions>
        </PlatformDialog>
    );
};

export default DeletePendingDomainDialog;
